module.exports = __webpack_public_path__ + "static/hero-contact-ba6a42136d326994748cc2faf2c89df2.jpg";